export default "__VITE_ASSET__a4bbebcd__"